import { render, staticRenderFns } from "./rec-keywords.vue?vue&type=template&id=05195594&scoped=true"
import script from "./rec-keywords.vue?vue&type=script&lang=js"
export * from "./rec-keywords.vue?vue&type=script&lang=js"
import style0 from "./rec-keywords.vue?vue&type=style&index=0&id=05195594&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05195594",
  null
  
)

export default component.exports